// ══════════════════════════════════════════════════════════════
//  Fashion-only category taxonomy for farniymart.shop
//  Only Women + Men clothing categories — nothing else.
// ══════════════════════════════════════════════════════════════

export const WOMEN_CATEGORIES = [
  { name: "Dresses", slug: "dresses", query: "dress" },
  { name: "Tops", slug: "tops", query: "top" },
  { name: "Shirts", slug: "shirts", query: "shirt" },
  { name: "T-Shirts", slug: "t-shirts", query: "t-shirt" },
  { name: "Blouses", slug: "blouses", query: "blouse" },
  { name: "Jeans", slug: "jeans", query: "jeans" },
  { name: "Trousers", slug: "trousers", query: "trouser" },
  { name: "Skirts", slug: "skirts", query: "skirt" },
  { name: "Co-ords", slug: "co-ords", query: "co-ords" },
  { name: "Jumpsuits", slug: "jumpsuits", query: "jumpsuit" },
  { name: "Ethnic Wear", slug: "ethnic-wear", query: "ethnic" },
  { name: "Sarees", slug: "sarees", query: "saree" },
  { name: "Kurtis", slug: "kurtis", query: "kurti" },
  { name: "Lehengas", slug: "lehengas", query: "lehenga" },
  { name: "Outerwear", slug: "outerwear", query: "outerwear" },
  { name: "Activewear", slug: "activewear", query: "activewear" },
  { name: "Nightwear", slug: "nightwear", query: "nightwear" },
];

export const MEN_CATEGORIES = [
  { name: "Shirts", slug: "shirts", query: "shirt" },
  { name: "T-Shirts", slug: "t-shirts", query: "t-shirt" },
  { name: "Polos", slug: "polos", query: "polo" },
  { name: "Jeans", slug: "jeans", query: "jeans" },
  { name: "Trousers", slug: "trousers", query: "trouser" },
  { name: "Formal Wear", slug: "formal-wear", query: "formal" },
  { name: "Blazers", slug: "blazers", query: "blazer" },
  { name: "Suits", slug: "suits", query: "suit" },
  { name: "Ethnic Wear", slug: "ethnic-wear", query: "ethnic" },
  { name: "Kurtas", slug: "kurtas", query: "kurta" },
  { name: "Jackets", slug: "jackets", query: "jacket" },
  { name: "Co-ords", slug: "co-ords", query: "co-ords" },
  { name: "Activewear", slug: "activewear", query: "activewear" },
  { name: "Nightwear", slug: "nightwear", query: "nightwear" },
];

export const FASHION_CATEGORIES = [
  {
    name: "Women",
    slug: "women",
    subcategories: WOMEN_CATEGORIES,
    image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&h=1000&fit=crop&q=85",
    description: "Curated collections for the modern woman",
  },
  {
    name: "Men",
    slug: "men",
    subcategories: MEN_CATEGORIES,
    image: "https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=800&h=1000&fit=crop&q=85",
    description: "Refined essentials for the contemporary man",
  },
];

export const findCategory = (gender, subcatSlug) => {
  const parent = FASHION_CATEGORIES.find((c) => c.slug === gender);
  if (!parent) return null;
  if (!subcatSlug) return parent;
  return parent.subcategories.find((s) => s.slug === subcatSlug) || null;
};

export const getCategoryQuery = (gender, subcatSlug) => {
  const subcat = findCategory(gender, subcatSlug);
  if (subcat?.query) return subcat.query;
  if (gender === "women") return "women";
  if (gender === "men") return "men";
  return "";
};
